import { render, staticRenderFns } from "./folder-menu.vue?vue&type=template&id=1263c1c6&%40click%3Aoutside=closeThisMenu&"
import script from "./folder-menu.vue?vue&type=script&lang=js&"
export * from "./folder-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports